import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';
import type { ReportMessagePageProps } from './components/ReportMessagePageContent';

const ReportMessagePageContent = lazy(
  () => import('./components/ReportMessagePageContent'),
);

export const ReportMessagePage = wrapLazyNavigatorScreen(
  (props: ReportMessagePageProps) => {
    return <ReportMessagePageContent {...props} />;
  },
  {
    headerShown: false,
  },
);
